// extracted by mini-css-extract-plugin
export default {"fixedHeightColumn":"-qCP7","center":"_29-+n","top":"nGt7U"};